import type { ReactNode } from "react";
import { BlockStack, Text } from "@shopify/polaris";

export interface GameCatalogSectionProps {
  /** Section heading (e.g. game family name) */
  title: string;
  /** Optional short description under the title */
  description?: string;
  /** Game cards or other content for this section */
  children: ReactNode;
}

/**
 * One catalog band: title, optional copy, then stacked cards.
 * Used for game families (Wheels, Scratch cards, …) as the catalog grows.
 */
export function GameCatalogSection({ title, description, children }: GameCatalogSectionProps) {
  return (
    <BlockStack gap="400">
      <BlockStack gap="150">
        <Text as="h2" variant="headingLg">
          {title}
        </Text>
        {description ? (
          <Text as="p" variant="bodyMd" tone="subdued">
            {description}
          </Text>
        ) : null}
      </BlockStack>
      <BlockStack gap="400">{children}</BlockStack>
    </BlockStack>
  );
}
